import { token } from '@atlaskit/tokens';
import DatasourcesRenderComponent, {
  type FieldTypeWithOnlyValues
} from '@databases/field-value';
import { defaultStoreUtils } from '@databases/redux';
import { type DatabaseFieldType } from '@databases/types/database';
import { getReferencedJiraValues } from '@databases/utils/database/field-types/jiraIssueDetails';
import { getDatabaseEntryRequired } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

const Container = styled.ul<{ isPriorityField?: boolean }>`
  list-style-type: none;
  padding: 0;

  > li + li {
    margin-top: ${token('space.050')};
  }

  .icon {
    // For priority field
    width: 16px;
  }

  ${({ isPriorityField }) =>
    isPriorityField
      ? `
        img {
          max-width: 16px;
          max-height: 16px;
        }
      `
      : `
        img {
          // For images in the description
          max-width: 100%;
          height: auto;
          overflow: hidden;
        }
      `}
`;

const JiraIssueDetailsValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.JIRA_ISSUE_DETAILS>
> = ({ contentId, field, entryId }) => {
  const targetValues = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, {
      contentId
    });
    const entry = entryId ? getDatabaseEntryRequired(database, entryId) : undefined;

    return getReferencedJiraValues({ database, field, entry }, state);
  });
  const isPriorityField = field.settings.jiraField === 'priority';

  if (!targetValues.length) {
    return null;
  } else {
    return (
      <Container isPriorityField={isPriorityField}>
        {targetValues.map((columnData, i) => {
          if (columnData.data != null) {
            const values = Array.isArray(columnData.data)
              ? columnData.data
              : [columnData.data];
            return (
              <li key={i}>
                <DatasourcesRenderComponent
                  item={
                    {
                      type: columnData.type,
                      text: columnData.text,
                      values
                    } as FieldTypeWithOnlyValues
                  }
                />
              </li>
            );
          }
        })}
      </Container>
    );
  }
};

export default JiraIssueDetailsValueView;
